import { createSlice } from '@reduxjs/toolkit'
import {
  customerAdminCreateUsers,
  customerAdminEditUser,
  customerAdminFilterBySummary,
  customerAdminGetByUserTypes,
  customerAdminRetrieveUserByID,
  customerAdminRetrieveUsers,
  customerAdminSearchUsers,
  customerAdminUpdateSelectedUser,
  customerAdminUserChangeStatus,
  customerAdminUsersPagination,
  customerAdminUsersSortBy,
  getCountForAllNonRegisterUsers,
  postBulkCreateForAllUsers,
  getBulkCreateUsersIsValid,
  getBulkCreateUsersProcessIsValid,
  customerAdminResetAlertHandler,
} from './customerAdminThunk'

const defaultPageSize = 9

const initialState = {
  loading: false,
  pageNumber: 0,
  pageSize: defaultPageSize,
  finalPage: false,
  summaries: {},
  activeSummary: '',
  sortBy: [],
  activeSort: {},
  activeSearch: '',
  value: [],
  updatedUser: {},
  userTypes: [],
  allNonRegisterUsersCount: 0,
  alert: {},
  batchStatusDetails: {},
  filterList: [],
  activeFilters: [],
  bulkCreateUsersIsValid: false,
  bulkCreateUsersProcessIsValid: false,
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  extraReducers: {

    [customerAdminResetAlertHandler.fulfilled]: (state) => {
      state.alert = {}
    },

    [customerAdminRetrieveUsers.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminRetrieveUsers.fulfilled]: (state, { payload }) => {
      state.value = payload.data.users
      state.summaries = payload.data.metadata
      state.updatedUser = {}
      state.activeSummary = Object.keys(payload.data.metadata)[0].toUpperCase()
      state.sortBy = payload.data.sort
      state.activeSort = payload.data.sort[0] || {}
      state.finalPage = payload.data.users.length < state.pageSize
      state.filterList = payload.userTypes
      state.loading = false
    },
    [customerAdminFilterBySummary.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminFilterBySummary.fulfilled]: (state, { payload }) => {
      state.pageNumber = 0
      state.value = payload.data.users
      state.summaries = payload.data.metadata
      state.filterList = payload.userTypes
      state.activeSummary = payload.summary
      state.sortBy = payload.data.sort
      state.activeSort = payload.data.sort[0] || {}
      state.finalPage = payload.data.users.length < state.pageSize
      state.loading = false
    },
    [customerAdminSearchUsers.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminSearchUsers.fulfilled]: (state, { payload }) => {
      state.pageNumber = 0
      state.value = payload.data.users
      state.filterList = payload.userTypes
      state.activeSearch = payload.search
      state.summaries = payload.data.metadata
      state.activeSummary = Object.keys(payload.data.metadata)[0].toUpperCase()
      state.sortBy = payload.data.sort
      state.activeSort = payload.data.sort[0] || {}
      state.finalPage = payload.data.users.length < state.pageSize
      state.loading = false
    },
    [customerAdminUsersSortBy.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminUsersSortBy.fulfilled]: (state, { payload }) => {
      state.value = payload.data.users
      state.filterList = payload.userTypes
      state.activeSort = payload.sort
      state.pageNumber = 0
      state.finalPage = payload.data.users.length < state.pageSize
      state.loading = false
    },
    [customerAdminRetrieveUserByID.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminRetrieveUserByID.fulfilled]: (state, { payload }) => {
      state.updatedUser = payload
      state.updatedUser.departments = payload.employee?.departments
      state.loading = false
    },
    [customerAdminUsersPagination.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminUsersPagination.fulfilled]: (state, { payload }) => {
      state.value.push(...payload.data.users)
      state.pageNumber = payload.pageNumber
      state.finalPage = payload.data.users.length < state.pageSize
      state.loading = false
    },
    [customerAdminGetByUserTypes.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminGetByUserTypes.fulfilled]: (state, { payload }) => {
      state.value = payload.data.users
      state.activeFilters = payload.activeFilter
      state.summaries = payload.data.metadata
      state.sortBy = payload.data.sort
      state.finalPage = payload.data.users.length < state.pageSize
      state.loading = false
    },
    [customerAdminUpdateSelectedUser.fulfilled]: (state, { payload }) => {
      state.updatedUser = payload
      state.loading = false
    },
    [customerAdminEditUser.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [customerAdminEditUser.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.updatedUser = {}
      state.alert = payload
    },
    [customerAdminEditUser.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [customerAdminCreateUsers.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [customerAdminCreateUsers.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [customerAdminCreateUsers.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.updatedUser = {}
      state.alert = payload
    },
    [customerAdminUserChangeStatus.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [customerAdminUserChangeStatus.fulfilled]: (state) => {
      state.pageNumber = 0
      state.loading = false
    },
    [customerAdminUserChangeStatus.rejected]: (state) => {
      state.loading = false
    },

    [getCountForAllNonRegisterUsers.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [getCountForAllNonRegisterUsers.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [getCountForAllNonRegisterUsers.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.allNonRegisterUsersCount = payload
      state.alert = {}
    },

    [postBulkCreateForAllUsers.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [postBulkCreateForAllUsers.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [postBulkCreateForAllUsers.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },

    [getBulkCreateUsersIsValid.pending]: (state) => {
      state.loading = true
    },
    [getBulkCreateUsersIsValid.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [getBulkCreateUsersIsValid.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.bulkCreateUsersIsValid = payload
      state.alert = {}
    },

    [getCountForAllNonRegisterUsers.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [getCountForAllNonRegisterUsers.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [getCountForAllNonRegisterUsers.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.allNonRegisterUsersCount = payload?.count || 0
      state.alert = {}
    },

    [postBulkCreateForAllUsers.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [postBulkCreateForAllUsers.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [postBulkCreateForAllUsers.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },

    [getBulkCreateUsersIsValid.pending]: (state) => {
      state.loading = true
    },
    [getBulkCreateUsersIsValid.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [getBulkCreateUsersIsValid.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.bulkCreateUsersIsValid = payload.enabled || false
      state.alert = {}
    },

    [getBulkCreateUsersProcessIsValid.pending]: (state) => {
      state.loading = true
    },
    [getBulkCreateUsersProcessIsValid.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [getBulkCreateUsersProcessIsValid.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.bulkCreateUsersProcessIsValid = payload.enabled || false
      state.alert = {}
    },

  },
})

export const customerAdminSelectUsers = ({ customerAdminUsers }) => customerAdminUsers

export default usersSlice.reducer
